/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Custom Component Library Revision
 * @export
 * @interface CustomComponentLibraryRevision
 */
export interface CustomComponentLibraryRevision {
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibraryRevision
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibraryRevision
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibraryRevision
     */
    customComponentLibraryId: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibraryRevision
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibraryRevision
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the CustomComponentLibraryRevision interface.
 */
export function instanceOfCustomComponentLibraryRevision(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "customComponentLibraryId" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function CustomComponentLibraryRevisionFromJSON(json: any): CustomComponentLibraryRevision {
    return CustomComponentLibraryRevisionFromJSONTyped(json, false);
}

export function CustomComponentLibraryRevisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibraryRevision {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'version': json['version'],
        'customComponentLibraryId': json['custom_component_library_id'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function CustomComponentLibraryRevisionToJSON(value?: CustomComponentLibraryRevision | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'version': value.version,
        'custom_component_library_id': value.customComponentLibraryId,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

